import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { invoicesApi, INVOICE_STATUS_LABEL, type InvoiceListItem } from '../crmApi'
import { ApiError } from '../api'

export function Invoices() {
  const navigate = useNavigate()
  const [rows, setRows] = useState<InvoiceListItem[]>([])
  const [unpaidOnly, setUnpaidOnly] = useState(false)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    setLoading(true)
    invoicesApi.list({ unpaidOnly })
      .then((r) => { setRows(r); setError(null) })
      .catch((e) => setError(e instanceof ApiError ? `Fel ${e.status}: ${e.body}` : String(e)))
      .finally(() => setLoading(false))
  }, [unpaidOnly])

  return (
    <div>
      <h1>Fakturor</h1>
      <p className="muted">Obetalda/delbetalda fakturor visas för påminnelsehantering (§6.12).</p>
      {error && <p className="error">{error}</p>}

      <div className="card filters">
        <label className="inline">
          <input type="checkbox" checked={unpaidOnly} onChange={(e) => setUnpaidOnly(e.target.checked)} />
          {' '}Endast obetalda/delbetalda
        </label>
      </div>

      {loading ? <p className="muted">Laddar…</p> : (
        <table className="grid">
          <thead><tr><th>Faktura</th><th>Kund</th><th>Datum</th><th>Förfaller</th><th>Summa</th><th>Kvar</th><th>Status</th></tr></thead>
          <tbody>
            {rows.map((i) => (
              <tr key={i.id} className="clickable" onClick={() => navigate(`/invoices/${i.id}`)}>
                <td>#{i.id}</td>
                <td>{i.customerName}</td>
                <td>{i.invoiceDate}</td>
                <td>{i.dueDate}</td>
                <td>{i.total.toFixed(2)} kr</td>
                <td>{i.remaining.toFixed(2)} kr</td>
                <td><span className="badge">{INVOICE_STATUS_LABEL[i.status]}</span></td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={7} className="muted">Inga fakturor.</td></tr>}
          </tbody>
        </table>
      )}
    </div>
  )
}
